import { Button, Grid, SxProps, Theme, Typography } from '@mui/material';
import { ProductRecommendationsDetails } from './product-recommendations-details';
import { useQuoteState } from 'shared/contexts';
import { useFormContext } from 'react-hook-form';
import { useGetProductRecommendations } from 'shared/queries';
import { ProductForm } from 'shared/types';

interface IProductRecommendationsContainerProps {
  styles: SxProps<Theme>;
}

export function ProductRecommendationsContainer({ styles }: IProductRecommendationsContainerProps) {
  const { editMode, recommendationsSelected, toggleNewProductByRecommendationDialog } = useQuoteState();
  const { watch } = useFormContext();
  const customerName = watch('customer.name');
  const productsOnQuote = watch('products') as ProductForm[];
  const { data } = useGetProductRecommendations(customerName);

  if (!data || data.length === 0) {
    return null;
  }

  const dataFiltered = data.filter(r => productsOnQuote.every(p => p.itemId !== r.itemid));
  if (dataFiltered.length === 0) {
    return null;
  }

  return (
    <Grid sx={styles}>
      <Grid container direction='row' justifyContent='space-between'>
        <Typography variant='h5'>Product Recommendations</Typography>
        {editMode && (
          <Grid item>
            <Button
              color='secondary'
              variant='contained'
              disabled={recommendationsSelected.length === 0}
              onClick={toggleNewProductByRecommendationDialog}
            >
              Add Products to Quote
            </Button>
          </Grid>
        )}
      </Grid>
      <ProductRecommendationsDetails data={dataFiltered} />
    </Grid>
  );
}
